const TIMESHEET_QUERY_ID = 'timesheet';

export default TIMESHEET_QUERY_ID;
